import i18next from 'i18next';

export const getCurrentDayjsLocale = (): 'ja' | 'en' => (i18next.language?.startsWith('en') ? 'en' : 'ja');
